import { useState } from 'react';

export const useFormField = (data: any[]) => {
	const [fields, setFields] = useState<any[]>(data);

	const setEnableStateInFields = (values: string[], isEnabled: boolean): void => {
		const newFields = fields;
		values.forEach((value: any) => {
			const findIndex = newFields.findIndex((field) => field.name === value);
			if (findIndex > -1) {
				newFields[findIndex].disabled = isEnabled;
			}
		});

		setFields(newFields);
	};

	return { fields, setFields, setEnableStateInFields } as const;
};
